import { UserAppPreferenceChartColors } from '../../../Core/Users/models/user-app-preferences-chart-colors.model';
import { chartColors } from '../enums/chart-colors.enum';


/**
 * This array is not const because User Preferences needs an easy way to pass user colors to charts that use
 * default colors. The future (better) way to do this is to use Factories for all chart models, and asynchronously grab
 * the colors.
 */
export let defaultSeriesColorConfig: chartColors[] = [
    chartColors.agprBlue,
    chartColors.agprPurple,
    chartColors.agprLightBlue,
    chartColors.agprOrange,
    chartColors.agprYellow,
    chartColors.agprLightGreen,
    chartColors.agprGreen,
    chartColors.agprTeal,
    chartColors.agprMediumBlue,
    chartColors.agprDarkPurple,
    chartColors.agprBlack
];

/**
 * Used by the ReportCreateDialogComponent in conjunction with UserPreferences to remap the array to use user colors/defaults
 */
export function setDefaultSeriesColorConfig(generalColors: UserAppPreferenceChartColors['generalColors']): chartColors[] {
    defaultSeriesColorConfig = Object.values(generalColors) as chartColors[];
    return defaultSeriesColorConfig;
}
